import ScreenReviewReportList from 'screens/ReviewReport/List';
import ScreenReviewReportDetails from 'screens/ReviewReport/Details';
import { REVIEW_REPORT } from 'routes/paths';

const reviewReportPermissions = {
  list: ['reviews.list_reviewreport', 'list_reviewreport'],
  view: ['reviews.view_reviewreport', 'view_reviewreport'],
};

const reviewReportRoutes = [
  {
    path: REVIEW_REPORT.LIST,
    name: 'review_reports_list',
    component: ScreenReviewReportList,
    loginRequired: true,
    allowPermissions: reviewReportPermissions.list,
  },
  {
    path: REVIEW_REPORT.DETAILS,
    name: 'review_reports_details',
    component: ScreenReviewReportDetails,
    loginRequired: true,
    allowPermissions: reviewReportPermissions.view,
  },
];

export default reviewReportRoutes;
